<template>
  <div>
    <b-row>
      <b-col md="2">
        <h6>No Label</h6>
        <hr />
        <McToggle v-model="checked" />
      </b-col>
      <b-col md="3">
        <h6>Label</h6>
        <hr />
        <McToggle v-model="checked" :label="label" placement="left" />
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col md="12">
        <h6>Disabled</h6>
      </b-col>
      <b-col md="2">
        <hr />
        <McToggle v-model="checked" disabled />
      </b-col>
      <b-col md="3">
        <hr />
        <McToggle v-model="checked" :label="label" placement="left" disabled />
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col md="12">
        <h6>Toggle Placement</h6>
      </b-col>
      <b-col md="2">
        <hr />
        <McToggle v-model="checked" :label="label" placement="left" />
      </b-col>
      <b-col md="3">
        <hr />
        <McToggle v-model="checked" :label="label" placement="left" />
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col md="12">
        <h6>Event</h6>
      </b-col>
      <b-col md="2">
        <hr />
        <McToggle v-model="checked" :label="label" placement="left" @change="onChange" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import McToggle from './index'

export default {
  components: {
    McToggle,
  },

  props: {
    label: String,
  },

  data() {
    return {
      checked: true,
    }
  },

  methods: {
    onChange() {
      alert('on change')
    },
  },
}
</script>
